import React, { useEffect, useState, useRef } from "react";
import { supabase } from "../../supabase-client";
import { ArrowLeft, Check, CircleX, Plus, X } from "lucide-react";
import Enviarmail from "../enviarmail";
import useAdministradores from "../getadministradores";
import TransferInstructions from "../TransferInstructions"; // 👈 Import the new component
import Cookies from "universal-cookie";
import getDolar from "../../utils/cotDolar";
import {
   processPayment,
   validateMercadoPagoData,
} from "../../services/mercadoPago";

const CotizacionModal = ({ cotizacion, onClose }) => {
   const token = process.env.REACT_APP_SUPABASE_ANON_KEY;
   const cookies = new Cookies();
   const [dolarRate, setDolarRate] = useState(0);
   const [logeado, setLogeado] = useState(false);
   const [vermediopago, setVerMediopago] = useState(false);
   const [mailAdmin, setMailAdmin] = useState("");
   const [paymentMethod, setPaymentMethod] = useState("");
   const [loadingAuth, setLoadingAuth] = useState(true);
   const [tabla, setTabla] = useState([]);
   const [textoPago, setTextoPago] = useState("");
   const [verBotones, setVerBotones] = useState("true");
   const divTransfRef = useRef(null);
   const divTranPago = useRef(null);

   const [saldoapagar, setSaldoapagar] = useState(0);

   // Buscar Administradores que reciben emails
   const { administradores, loading, error, refetch } = useAdministradores();
   // Estados que no muestran botones de accion
   const sacarBoton = [
      "anticipo",
      "anulado",
      "entregado",
      "terminado",
      "procesando",
      "finalizado",
   ];

   const [editRecord, setEditRecord] = useState({
      id: 0,
      titulo: "",
      detalle: "",
      usuario_id: 0,
      alto: 0,
      ancho: 0,
      profundidad: 0,
      precio: 0,
      porcentaje: 0,
      anticipo: 0,
      saldo: 0,
      estado: "Pendiente",
   });

   const [userRecord, setUserRecord] = useState({
      email: "",
      nombre: "",
      documento: 1,
      celular: "",
      perfil: 18,
      id: 0,
   });

   const [dirRecord, setDirRecord] = useState({
      calle: "",
      ciudad: "",
      provincia: "",
      codigo_postal: "",
   });

   const fetchTabla = async () => {
      const { error, data } = await supabase
         .from("tabla")
         .select("*")
         .eq("cod", 6)
         .gt("orden", 1)
         .order("cod", { ascending: true })
         .order("orden", { ascending: true });

      if (error) {
         console.error("Error reading tabla: ", error.message);
         return;
      }

      setTabla(data);
   };

   useEffect(() => {
      const fetchDolar = async () => {
         const rate = await getDolar();
         setDolarRate(rate);
      };

      fetchDolar();
   }, []);

   useEffect(() => {
      if (paymentMethod === "transferencia" && divTransfRef.current) {
         setTextoPago("Pagado por Transferencia");
         setTimeout(() => {
            divTransfRef.current.focus();
            divTransfRef.current.scrollIntoView({
               behavior: "smooth",
               block: "nearest",
            });
         }, 100);
      } else {
         setTextoPago("Pagar con Tarjeta de Crédito");
      }
   }, [paymentMethod]);

   useEffect(() => {
      if (divTranPago.current) {
         setTimeout(() => {
            divTranPago.current.focus();
            divTranPago.current.scrollIntoView({
               behavior: "smooth",
               block: "nearest",
            });
         }, 100);
      }
   }, [vermediopago]);

   useEffect(() => {
      if (cotizacion) {
         setEditRecord({
            id: cotizacion.id,
            titulo: cotizacion.titulo || "",
            detalle: cotizacion.detalle || "",
            alto: cotizacion.alto || 0,
            ancho: cotizacion.ancho || 0,
            profundidad: cotizacion.profundidad || 0,
            precio: cotizacion.precio || 0,
            porcentaje: cotizacion.porcentaje || 0,
            anticipo: cotizacion.anticipo || 0,
            saldo: cotizacion.saldo || 0,
            estado: cotizacion.estado || "Pendiente",
            usuario_id: cotizacion.usuario_id || 0,
            cod_obra: cotizacion.cod_obra || 0,
         });
         if (
            cotizacion.estado === "cotizado" ||
            cotizacion.estado === "anticipo"
         ) {
            setTextoPago("Pagar Anticipo");
            setSaldoapagar(cotizacion.anticipo);
         }
         if (cotizacion.estado === "terminado") {
            setTextoPago("Saldo a pagar");
            setSaldoapagar(cotizacion.saldo);
         }
      }
      fetchTabla();

      if (sacarBoton.indexOf(cotizacion.estado) !== -1) {
         console.log(
            "cotizacion.estado: ",
            cotizacion.estado,
            sacarBoton.indexOf(cotizacion.estado)
         );
         setVerBotones(false);
      }
   }, [cotizacion]);

   // 👈 Simplified and more robust approach
   useEffect(() => {
      if (loading || error || mailAdmin !== "") return;

      if (administradores && administradores.length > 0) {
         const emails = administradores
            .map((admin) => admin.email)
            .filter((email) => email && email.trim() !== "") // Filter out empty emails
            .join(",");

         if (emails) {
            console.log("Admin emails loaded:", emails);
            setMailAdmin(emails);
            // alert(emails); // Remove this in production
         } else {
            console.warn("No valid admin emails found");
         }
      } else {
         console.log("No administradores data available");
      }
   }, [administradores, loading, error, mailAdmin]);

   const mp_url = {
      success: `https://diegocurutchet.com.ar/success?collection_id=${cotizacion.id}&pago=adelanto`,
      failure: `https://diegocurutchet.com.ar/failure?collection_id=${cotizacion.id}`,
      pending: `https://diegocurutchet.com.ar/pending?collection_id=${cotizacion.id}`,
   };
   const handleClose = (e) => {
      if (e) {
         e.preventDefault();
         e.stopPropagation();
      }

      setEditRecord({
         id: 0,
         titulo: "",
         detalle: "",
         usuario_id: 0,
         alto: 0,
         ancho: 0,
         profundidad: 0,
         precio: 0,
         porcentaje: 0,
         saldo: 0,
         estado: "Pendiente",
      });

      setVerMediopago(false);
      setPaymentMethod("");

      if (onClose && typeof onClose === "function") {
         onClose();
      }
   };

   useEffect(() => {
      const handleKeyDown = (e) => {
         if (e.key === "Escape") {
            handleClose();
         }
      };

      document.addEventListener("keydown", handleKeyDown);
      return () => document.removeEventListener("keydown", handleKeyDown);
   }, []);

   const fetchUser = async () => {
      console.log("fetchUser: ");
      setLoadingAuth(true);

      try {
         const { data: users, error: fetchError } = await supabase
            .from("usuarios")
            .select("*")
            .eq("password_hash", localStorage.getItem("authjwt"))
            .single();

         if (fetchError) {
            console.error("Error fetching user:", fetchError);
            setLogeado(false);
            return;
         }

         console.log("users: ", users);
         if (users) {
            setLogeado(true);
            setUserRecord({
               email: users.email || "",
               nombre: users.nombre || "",
               celular: users.celular || "",
               documento: users.documento || 1,
               perfil: users.perfil || 18,
               id: users.id || 0,
            });
         } else {
            setLogeado(false);
         }
      } catch (error) {
         console.error("Error in fetchUser:", error);
         setLogeado(false);
      } finally {
         setLoadingAuth(false);
      }
   };

   useEffect(() => {
      fetchUser();
   }, []);

   const handleRespuesta = async (respuesta) => {
      var notificacion = "";
      var pagoRealizado = (editRecord.precio -
               (editRecord.precio -
                  (editRecord.precio * editRecord.porcentaje) / 100)) *
                  dolarRate;
      notificacion = `Se ha hecho una transferencia bancaria de $ ${pagoRealizado}.
      <br/>Por favor verifique en su cuenta bancaria si se acredito dicha transferencia.`;
      if (
         textoPago !== "Pagado por Transferencia" &&
         respuesta === "anticipo"
      ) {
         // mercadogpago
         notificacion = `Se ha hecho un pago a travez de Mercado Pago de $ ${pagoRealizado}.
         <br/>Por favor verifique en su cuenta bancaria si se acredito dicha transferencia.`;
         const newOrder = {
            id: editRecord.id,
         };
         const totalAmount =
            (editRecord.precio -
               (editRecord.precio -
                  (editRecord.precio * editRecord.porcentaje) / 100)) *
                  dolarRate;
                  
         const cotpago = {
            cotizacion_id: editRecord.id,
            dolar: dolarRate,
            pesos: totalAmount,
            precio: editRecord.precio,
            estado: respuesta,
         };
         const { error } = await supabase
            .from("cotizacion_pagos")
            .insert(cotpago);

         if (error) {
            console.error("Error creating cotizacion_pagos", error);
            alert(`Error: ${error.message}`);
            return;
         }

         const cartObras = [
            {
               id: 1,
               title: editRecord.titulo,
               medidas: `Medidas: ${editRecord.alto}x${editRecord.ancho}x${editRecord.profundidad} cm`,
               quantity: 1,
               precio:
                  (editRecord.precio -
                     (editRecord.precio -
                        (editRecord.precio * editRecord.porcentaje) / 100)) *
                  dolarRate,
               currency_id: "ARS",
            },
         ];

         const orderData = {
            newOrder,
            mp_url,
            cartObras,
            userRecord,
            dirRecord,
            totalAmount,
         };
         console.log("orderData: ", orderData);
         const paymentResult = await processPayment(orderData, token, false);

         if (paymentResult.success) {
            console.log("🎉 Payment process initiated successfully");

            // Show success message
            alert(
               "Pedido creado exitosamente. Serás redirigido a MercadoPago para completar el pago."
            );

            // Optionally redirect to a success page
            // navigate("/order-success", { state: { orderId: newOrder.id } });
         } else {
            console.error(
               "❌ Payment processing failed:",
               paymentResult.message
            );
            alert(`Error al procesar el pago: ${paymentResult.message}`);
         }

         return;
      }
      try {
         const { error } = await supabase
            .from("cotizacion")
            .update({ estado: respuesta })
            .eq("id", editRecord.id);

         if (error) {
            console.error("Error updating cotización:", error);
            alert(`Error: ${error.message}`);
            return;
         }
         // Grabo Historial
         const { error: fetchError } = await supabase
            .from("cotizacion_hist")
            .insert({
               cotizacion_id: editRecord.id,
               estado: editRecord.estado,
            });

         if (fetchError) {
            console.error("Error inserting into cotizacion_hist:", fetchError);
            alert(`Error: ${fetchError.message}`);
            return;
         }

         console.log("✅ Cotización actualizada exitosamente");
      } catch (error) {
         console.error("Error in handleRespuesta:", error);
         alert("Error inesperado al guardar");
      }

      const resp = await Enviarmail({
         aquien: mailAdmin,
         reply_to: userRecord.email,
         asunto: "Cambio de Estado a una Cotización",
         texto: `
         <div style="font-family: Arial, sans-serif; max-width: 600px; margin: 0 auto; padding: 20px; border: 1px solid #ddd; border-radius: 8px;">
         <h3 style="color: #333; margin: 0;">Detalles del Cambio:</h3>
         <div style="margin-bottom: 15px;">
            Aviso: La cotización numero <b>${editRecord.id}</b>  
         </div>
         <div style="margin-bottom: 15px;">
            Titulo : <b>${editRecord.titulo}</b>
         </div>
         <div style="margin-bottom: 15px;">
            Detalle : <b>${editRecord.detalle}</b> 
         </div>
         <div style="margin-bottom: 15px;">
            ${notificacion}
         </div>
         <div style="margin-top: 20px; padding: 15px; background-color: #e8f5e8; border-radius: 5px;">
         <p style="margin: 0; font-size: 14px; color: #666;">
         <strong>Nota:</strong> Ingrese <a href="${window.location.origin}">aqui</a> 
         para acceder a la APP.</p>
         </div>
         </div>`,
      });

      if (!resp) {
         console.log("resp: ", resp);
         console.error("Error enviando email de notificación");
         alert(
            "Error enviando notificación a administradores por email" +
               mailAdmin
         );
      }
      // Notifico al usuario que sera notificado al terminar la obra
      if (respuesta === "aceptado") {
         const respuser = await Enviarmail({
            aquien: userRecord.email,
            reply_to: userRecord.email,
            asunto: "Cambio de Estado a una Cotización",
            texto: `
            <div style="font-family: Arial, sans-serif; max-width: 600px; margin: 0 auto; padding: 20px; border: 1px solid #ddd; border-radius: 8px;">
            <div style="margin-bottom: 15px;">
               Su obra <b>${editRecord.titulo}</b> comenzara a crearse pronto.<p>
               Le estaremos informando los avances y la fecha estimada de entrega.</p>
               <p>Muchas gracias por confiar en nosotros.</p>
               </div>
            </div>
            </div>`,
         });

         if (!respuser) {
            console.log("resp: ", respuser);
            console.error("Error enviando email de notificación");
         }
      }

      console.log("✅ Cotización actualizada exitosamente");

      handleClose();
   };

   const handleMediopago = async () => {
      if (editRecord.porcentaje === 0) {
         handleRespuesta("aceptado");
         return;
      }

      setVerMediopago(true);
   };

   const handleSave = async () => {
      try {
         if (!editRecord.titulo.trim()) {
            alert("Por favor ingrese un título");
            return;
         }

         if (editRecord.id === 0) {
            const { id, ...newRecord } = editRecord;

            const recordToInsert = {
               ...newRecord,
               usuario_id: userRecord.id,
               precio: 0,
               anticipo: 0,
               saldo: 0,
               estado: "pendiente",
            };

            const { data: newdata, error } = await supabase
               .from("cotizacion")
               .insert(recordToInsert)
               .select()
               .single();

            if (error) {
               console.error("Error creating cotización:", error);
               alert(`Error: ${error.message}`);
               return;
            }

            // Grabo Historial
            const { error: fetchError } = await supabase
               .from("cotizacion_hist")
               .insert({
                  cotizacion_id: newdata.id,
                  estado: recordToInsert.estado,
               });

            if (fetchError) {
               console.error(
                  "Error inserting into cotizacion_hist:",
                  fetchError
               );
               alert(`Error: ${fetchError.message}`);
               return;
            }

            const resp = await Enviarmail({
               aquien: mailAdmin,
               reply_to: userRecord.email,
               asunto: "Creado una Cotización",
               texto: `
                  <div style="font-family: Arial, sans-serif; max-width: 600px; margin: 0 auto; padding: 20px; border: 1px solid #ddd; border-radius: 8px;">
                  <h3 style="color: #333; margin: 0;">Detalles del Cambio:</h3>
                  <div style="margin-bottom: 15px;">
                  ${userRecord.nombre} ha creado la cotizacion numero: <b>${newdata.id}</b>
                  </div>
                  <div style="margin-bottom: 15px;">
                  Titulo : <b>${editRecord.titulo}</b>.
                  </div>
                  <div style="margin-bottom: 15px;">
                  Detalle : <b>${editRecord.detalle}</b>.
                  </div>
                  Medidas: Alto: <b>${editRecord.alto}</b> cm, Ancho: <b>${editRecord.ancho}</b> cm, Profundidad: <b>${editRecord.profundidad}</b> cm
                  <div style="margin-top: 20px; padding: 15px; background-color: #e8f5e8; border-radius: 5px;">
                  <p style="margin: 0; font-size: 14px; color: #666;">
                  <strong>Nota:</strong> Ingrese <a href="${window.location.origin}">aqui</a> 
                  para acceder a la APP.</p>
                  </div>
                  </div>`,
            });
            console.log("✅ Cotización creada exitosamente");
         } else {
            const updateData = {
               titulo: editRecord.titulo,
               detalle: editRecord.detalle,
               alto: editRecord.alto,
               ancho: editRecord.ancho,
               profundidad: editRecord.profundidad,
               precio: editRecord.precio,
               porcentaje: editRecord.porcentaje,
               saldo: editRecord.saldo,
               estado: editRecord.estado,
            };

            const { error } = await supabase
               .from("cotizacion")
               .update(updateData)
               .eq("id", editRecord.id);

            if (error) {
               console.error("Error updating cotización:", error);
               alert(`Error: ${error.message}`);
               return;
            }
            // Grabo Historial
            const { error: fetchError } = await supabase
               .from("cotizacion_hist")
               .insert({
                  cotizacion_id: editRecord.id,
                  estado: editRecord.estado,
               });

            if (fetchError) {
               console.error(
                  "Error inserting into cotizacion_hist:",
                  fetchError
               );
               alert(`Error: ${fetchError.message}`);
               return;
            }
            const resp = await Enviarmail({
               aquien: mailAdmin,
               reply_to: userRecord.email,
               asunto: "Se modifico la Cotización",
               texto: `La cotización numero <b>${editRecord.id}</b> con titulo : <b>${editRecord.titulo}</b> ha sido modificada.`,
            });

            console.log("✅ Cotización actualizada exitosamente");
         }

         handleClose();
      } catch (error) {
         console.error("Error in handleSave:", error);
         alert("Error inesperado al guardar");
      }
   };

   // 👈 Loading state - fully responsive
   if (loadingAuth) {
      return (
         <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-2 sm:p-4 z-50">
            <div className="bg-white p-4 sm:p-6 rounded-lg shadow-lg w-full max-w-md text-center">
               <div className="animate-spin rounded-full h-8 w-8 sm:h-12 sm:w-12 border-2 border-blue-500 border-t-transparent mx-auto mb-4"></div>
               <h2 className="text-lg sm:text-xl font-bold mb-2">
                  Verificando autenticación...
               </h2>
               <p className="text-sm sm:text-base text-gray-600">
                  Por favor espere un momento
               </p>
            </div>
         </div>
      );
   }

   // 👈 Auth required - fully responsive
   if (!logeado) {
      return (
         <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-2 sm:p-4 z-50">
            <div className="bg-white p-4 sm:p-6 rounded-lg shadow-lg w-full max-w-md">
               <h2 className="text-lg sm:text-xl font-bold mb-4">
                  Autenticación Requerida
               </h2>
               <p className="text-sm sm:text-base mb-4">
                  Para utilizar esta página necesitas autenticarte. Por favor,
                  inicia sesión.
               </p>
               <div className="flex flex-col sm:flex-row justify-end gap-2 sm:gap-3">
                  <button
                     onClick={handleClose}
                     className="btn-gray-light order-2 sm:order-1"
                  >
                     Cerrar
                  </button>
                  <a
                     href="/login"
                     className="btn-blue order-1 sm:order-2 text-center"
                  >
                     Ir a Login
                  </a>
               </div>
            </div>
            <div className="absolute inset-0 -z-10" onClick={handleClose} />
         </div>
      );
   }
   if (editRecord.cod_obra > 0) {
      let cart = cookies.get("obra") || [];
      // If not array, make it array
      if (!Array.isArray(cart)) cart = [];
      // Add the new id if not already in cart
      if (!cart.includes(editRecord.cod_obra)) cart.push(editRecord.cod_obra);
      // Save back to cookies
      cookies.set("obra", cart, { path: "/" });
      // Dispatch custom event to notify Navbar
      window.dispatchEvent(new Event("cartUpdated"));
   }



   return (
      <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-2 sm:p-4 z-50">
         <div
            className="w-full max-w-6xl bg-white rounded-lg shadow-lg relative z-10 max-h-[95vh] overflow-y-auto mx-2 sm:mx-4"
            onClick={(e) => e.stopPropagation()}
         >
            {/* 👈 Responsive header */}
            <div className="sticky top-0 bg-white border-b p-3 sm:p-4 flex justify-between items-center z-20">
               <h2 className="text-lg sm:text-2xl font-bold pr-4">
                  Cotización
               </h2>
               <button
                  onClick={handleClose}
                  className="text-gray-400 hover:text-gray-600 transition-colors p-1"
               >
                  <X className="w-5 h-5 sm:w-6 sm:h-6" />
               </button>
            </div>

            {/* 👈 Responsive content container */}
            <div className="p-3 sm:p-4 lg:p-6">
               <div className="bg-white rounded-lg border p-3 sm:p-4 shadow-md">
                  {/* 👈 Responsive form fields */}
                  <div className="space-y-4">
                     {/* Title field */}
                     <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-2 sm:gap-4">
                        <label className="block text-sm font-medium text-gray-700 sm:w-48 flex-shrink-0">
                           Título *
                        </label>
                        <input
                           className="w-full p-2 sm:p-3 border rounded focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm sm:text-base"
                           value={editRecord.titulo || ""}
                           placeholder="Un título descriptivo de la obra"
                           onChange={(e) =>
                              setEditRecord({
                                 ...editRecord,
                                 titulo: e.target.value,
                              })
                           }
                           required
                        />
                     </div>

                     {/* Detail field */}
                     <div className="flex flex-col sm:flex-row sm:justify-between sm:items-start gap-2 sm:gap-4">
                        <label className="block text-sm font-medium text-gray-700 sm:w-48 flex-shrink-0 sm:mt-2">
                           Detalle de la obra
                        </label>
                        <textarea
                           className="w-full p-2 sm:p-3 border rounded focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm sm:text-base"
                           rows={3}
                           value={editRecord.detalle || ""}
                           placeholder="Describe los detalles de la obra que deseas cotizar..."
                           onChange={(e) =>
                              setEditRecord({
                                 ...editRecord,
                                 detalle: e.target.value,
                              })
                           }
                        />
                     </div>

                     {/* 👈 Responsive dimensions grid */}
                     <div></div>
                     <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 sm:gap-4 justify-items-end">
                        <div className="flex">
                           <label className="content-center block mb-1 sm:mb-2 text-sm font-medium text-gray-700">
                              Alto (cm)
                           </label>
                           <input
                              type="number"
                              className="m-2 p-2 w-[100px] sm:p-3 border rounded focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm sm:text-base text-right"
                              value={editRecord.alto || ""}
                              min="0"
                              step="0.1"
                              onChange={(e) =>
                                 setEditRecord({
                                    ...editRecord,
                                    alto: parseFloat(e.target.value) || 0,
                                 })
                              }
                           />
                           <label className="content-center block mb-1 sm:mb-2 text-sm font-medium text-gray-400">
                              dato opcional
                           </label>
                        </div>
                        <div className="flex ">
                           <label className="content-center block mb-1 sm:mb-2 text-sm font-medium text-gray-700">
                              Ancho (cm)
                           </label>
                           <input
                              type="number"
                              className="m-2 p-2 w-[100px] sm:p-3 border rounded focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm sm:text-base  text-right"
                              value={editRecord.ancho || ""}
                              min="0"
                              step="0.1"
                              onChange={(e) =>
                                 setEditRecord({
                                    ...editRecord,
                                    ancho: parseFloat(e.target.value) || 0,
                                 })
                              }
                           />
                           <label className="content-center block mb-1 sm:mb-2 text-sm font-medium text-gray-400">
                              dato opcional
                           </label>
                        </div>
                        <div className="flex sm:col-span-2 lg:col-span-1">
                           <label className="content-center block mb-1 sm:mb-2 text-sm font-medium text-gray-700">
                              Profundidad (cm)
                           </label>
                           <input
                              type="number"
                              className="m-2 p-2 w-[100px] sm:p-3 border rounded focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm sm:text-base  text-right"
                              value={editRecord.profundidad || ""}
                              min="0"
                              step="0.1"
                              onChange={(e) =>
                                 setEditRecord({
                                    ...editRecord,
                                    profundidad:
                                       parseFloat(e.target.value) || 0,
                                 })
                              }
                           />
                           <label className="content-center block mb-1 sm:mb-2 text-sm font-medium text-gray-400">
                              dato opcional
                           </label>
                        </div>
                     </div>

                     {/* 👈 Responsive price display */}
                     {editRecord.precio > 0 && (
                        <>
                           <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 sm:gap-4 p-3 sm:p-4 bg-green-50 rounded-lg mt-4">
                              <div className="text-center">
                                 <label className="block text-xs sm:text-sm font-medium text-gray-700 mb-1">
                                    Precio
                                 </label>
                                 <div className="text-xl sm:text-2xl font-bold text-green-600">
                                    U$S{" "}
                                    {Number(editRecord.precio).toLocaleString()}
                                 </div>
                              </div>
                              <div className="text-center">
                                 <label className="block text-xs sm:text-sm font-medium text-gray-700 mb-1">
                                    Anticipo Requerido
                                 </label>
                                 <div className="text-lg sm:text-xl font-semibold text-blue-600">
                                    {Number(
                                       editRecord.porcentaje
                                    ).toLocaleString()}
                                    %
                                 </div>
                              </div>
                              <div className="text-center sm:col-span-2 lg:col-span-1">
                                 <label className="block text-xs sm:text-sm font-medium text-gray-700 mb-1">
                                    Anticipo a pagar
                                 </label>
                                 <div className="text-xl sm:text-2xl font-bold text-green-600">
                                    U$S{" "}
                                    {editRecord.porcentaje > 0 && (
                                       <span>
                                          {Number(
                                             editRecord.precio -
                                                (editRecord.precio -
                                                   (editRecord.precio *
                                                      editRecord.porcentaje) /
                                                      100)
                                          ).toLocaleString()}
                                       </span>
                                    )}
                                 </div>
                              </div>
                           </div>
                           <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 sm:gap-4 p-3 sm:p-4 bg-green-50 rounded-lg mt-4">
                              <div className="text-center">
                                 <label className="block text-xs sm:text-sm font-medium text-gray-700 mb-1">
                                    Cotizacion Dolar HOY:
                                 </label>
                                 <div className="text-lg sm:text-xl font-semibold text-blue-600">
                                    $ {Number(dolarRate).toLocaleString()}
                                 </div>
                              </div>
                              <div className="text-center sm:col-span-2 lg:col-span-1">
                                 <label className="block text-xs sm:text-sm font-medium text-gray-700 mb-1">
                                    Saldo a pagar
                                 </label>
                                 <div className="text-xl sm:text-2xl font-bold text-green-600">
                                    U$S <span>{saldoapagar}</span>
                                 </div>
                              </div>
                              <div className="text-center sm:col-span-2 lg:col-span-1">
                                 <label className="block text-xs sm:text-sm font-medium text-gray-700 mb-1">
                                    {textoPago}
                                 </label>
                                 <div className="text-xl sm:text-2xl font-bold text-green-600">
                                    ${" "}
                                    {editRecord.porcentaje > 0 && (
                                       <span>
                                          {Number(
                                             saldoapagar * dolarRate
                                          ).toLocaleString()}
                                       </span>
                                    )}
                                 </div>
                              </div>
                           </div>
                        </>
                     )}
                  </div>
               </div>
               {editRecord.cod_obra === 0 && verBotones && (
                  <>
                     {/* 👈 Responsive action buttons */}
                     <div className="flex flex-col sm:flex-row justify-center sm:justify-end gap-2 sm:gap-3 mt-4 sm:mt-6 pt-3 sm:pt-4 border-t">
                        {editRecord.precio === 0 && (
                           <>
                              <button
                                 onClick={() => handleRespuesta("anulado")}
                                 disabled={!editRecord.titulo.trim()}
                                 className="btn-red flex items-center justify-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed order-2 sm:order-2 text-sm sm:text-base"
                              >
                                 <CircleX className="w-4 h-4" />
                                 <span className="hidden sm:inline">
                                    Anular Cotización
                                 </span>
                                 <span className="sm:hidden">Anular</span>
                              </button>
                              <button
                                 onClick={handleSave}
                                 disabled={!editRecord.titulo.trim()}
                                 className="btn-green flex items-center justify-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed order-1 sm:order-2 text-sm sm:text-base"
                              >
                                 <Plus className="w-4 h-4" />
                                 <span className="hidden sm:inline">
                                    {editRecord.id === 0
                                       ? "Solicitar Cotización"
                                       : "Actualizar"}
                                 </span>
                                 <span className="sm:hidden">
                                    {editRecord.id === 0
                                       ? "Crear"
                                       : "Actualizar"}
                                 </span>
                              </button>
                           </>
                        )}

                        {editRecord.precio !== 0 && !vermediopago && (
                           <>
                              <button
                                 onClick={() => handleRespuesta("anulado")}
                                 disabled={!editRecord.titulo.trim()}
                                 className="btn-red flex items-center justify-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed order-2 sm:order-2 text-sm sm:text-base"
                              >
                                 <CircleX className="w-4 h-4" />
                                 <span className="hidden sm:inline">
                                    Anular Cotización
                                 </span>
                                 <span className="sm:hidden">Anular</span>
                              </button>
                              <button
                                 onClick={() => handleMediopago()}
                                 disabled={!editRecord.titulo.trim()}
                                 className="btn-green flex items-center justify-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed order-1 sm:order-3 text-sm sm:text-base"
                              >
                                 <Check className="w-4 h-4" />
                                 <span className="hidden sm:inline">
                                    Aceptar Cotización
                                 </span>
                                 <span className="sm:hidden">Aceptar</span>
                              </button>
                           </>
                        )}
                     </div>

                     {/* 👈 Responsive payment methods */}
                     {vermediopago && (
                        <>
                           <div
                              id="divPago"
                              name="divPago"
                              ref={divTranPago}
                              tabIndex="0"
                              className="mt-4 sm:mt-6 p-3 sm:p-4 bg-blue-50 border border-blue-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                           >
                              <h3 className="text-base sm:text-lg font-bold mb-3 sm:mb-4">
                                 Medios de Pago
                              </h3>

                              {/* 👈 Responsive payment options */}
                              <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4">
                                 <label className="flex items-center p-3 sm:p-4 border rounded-lg cursor-pointer hover:bg-gray-50 transition-colors">
                                    <input
                                       type="radio"
                                       name="paymentMethod"
                                       value="creditCard"
                                       checked={paymentMethod === "creditCard"}
                                       onChange={() =>
                                          setPaymentMethod("creditCard")
                                       }
                                       className="mr-3 sm:mr-4 w-4 h-4"
                                    />
                                    <span className="text-sm sm:text-base font-medium">
                                       Tarjeta de Crédito
                                    </span>
                                 </label>

                                 <label className="flex items-center p-3 sm:p-4 border rounded-lg cursor-pointer hover:bg-gray-50 transition-colors">
                                    <input
                                       type="radio"
                                       name="paymentMethod"
                                       value="transferencia"
                                       checked={
                                          paymentMethod === "transferencia"
                                       }
                                       onChange={() =>
                                          setPaymentMethod("transferencia")
                                       }
                                       className="mr-3 sm:mr-4 w-4 h-4"
                                    />
                                    <span className="text-sm sm:text-base font-medium">
                                       Transferencia
                                    </span>
                                 </label>
                              </div>

                              {/* 👈 Responsive transfer instructions */}
                              {paymentMethod === "transferencia" && (
                                 <TransferInstructions
                                    ref={divTransfRef}
                                    tabla={tabla}
                                    textoPago={textoPago}
                                 />
                              )}
                           </div>
                           {paymentMethod && (
                              <div>
                                 <button
                                    onClick={() => handleRespuesta("anticipo")}
                                    disabled={!editRecord.titulo.trim()}
                                    className="btn-green flex items-center justify-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed order-1 sm:order-3 text-sm sm:text-base"
                                 >
                                    <Check className="w-4 h-4" />
                                    <span className="hidden sm:inline">
                                       {textoPago}
                                    </span>
                                    <span className="sm:hidden">
                                       {textoPago}
                                    </span>
                                 </button>
                              </div>
                           )}
                        </>
                     )}
                  </>
               )}
            </div>
            {editRecord.cod_obra === 0 ? (
               <div className="flex flex-col sm:flex-row justify-center sm:justify-end gap-2 sm:gap-3 mt-4 sm:mt-6 pt-3 sm:pt-4 ">
                  <button
                     onClick={handleClose}
                     className="btn-gray-light flex items-center justify-center gap-2 order-3 sm:order-1 text-sm sm:text-base"
                  >
                     <ArrowLeft className="w-4 h-4" /> Volver
                  </button>
               </div>
            ) : null}

            {editRecord.estado === "terminada" ? (
               <div className="h-auto p-6 bg-green-50 border border-green-200 rounded-lg m-4">
                  <p className="text-2xl text-blue-700 text-center">
                     Felicitaciones esta obra ha sido terminada.{" "}
                  </p>
                  <p className="text-2xl  text-blue-700 text-center">
                     {" "}
                     Cierre esta Ventana y entre a su Carrito para continuar con
                     la compra.
                  </p>
                  <br />
               </div>
            ) : null}
         </div>

         {/* Click outside to close */}
         <div className="absolute inset-0 -z-10" onClick={handleClose} />
      </div>
   );
};

export default CotizacionModal;
